const services = [
  {
    slug: 'custom-software',
    title: 'Custom Software Development',
    short: 'End-to-end custom applications for web and cloud.',
    image: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=1400&q=80&auto=format&fit=crop',
    description: `We design and build scalable, secure, and maintainable custom software tailored to your business workflows. Our teams handle requirements, architecture, development, testing, and deployment so you can focus on outcomes. Typical projects include enterprise internal tools, customer portals, and bespoke integrations with third-party systems.`,
    features: [
      'Microservices & modular architecture',
      'REST & GraphQL APIs',
      'Cloud-native (AWS / Azure / GCP)',
      'CI/CD and automated testing'
    ],
    tech: ['Java / Spring Boot', 'Node.js', 'Postgres / MySQL', 'Docker & Kubernetes'],
    approach: 'We run a discovery sprint, design the architecture, then deliver iterative releases with automated tests and CI/CD pipelines. Our teams include a product manager, engineers, QA, and SRE support for production hardening.',
    typicalDuration: '3 - 12 months',
    teamSize: '4 - 12'
  },
  {
    slug: 'web-mobile',
    title: 'Web & Mobile App Development',
    short: 'Beautiful, performant web and native-feel mobile apps.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1400&q=80&auto=format&fit=crop',
    description: `We build responsive web apps and cross-platform mobile apps with a focus on UX and performance. Our UI designers and engineers collaborate to ship polished experiences that delight users and drive retention. From PWA to React Native and Flutter, we choose the right stack for your needs.`,
    features: [
      'Responsive & accessible UI',
      'React, Next.js, React Native',
      'Performance & analytics instrumentation',
      'App store publishing support'
    ],
    tech: ['React / Next.js', 'React Native', 'TypeScript', 'Sentry / Analytics'],
    approach: 'Product-focused teams combine design sprints with rapid prototyping and a strong QA pipeline. We ship MVPs fast then improve based on user metrics and A/B testing.',
    typicalDuration: '2 - 9 months',
    teamSize: '3 - 8'
  },
  {
    slug: 'cloud-devops',
    title: 'Cloud Solutions & DevOps',
    short: 'Migrate, modernize and run reliable cloud platforms.',
    image: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1400&q=80&auto=format&fit=crop',
    description: `We help organizations adopt cloud best practices, design resilient architectures, and automate delivery pipelines. Our engineers optimize cost, security, and availability while operationalizing monitoring and incident response.`,
    features: [
      'Cloud migration & architecture',
      'Infrastructure as Code (Terraform)',
      'CI/CD, observability & SRE practices',
      'Security & compliance readiness'
    ],
    tech: ['AWS / Azure / GCP', 'Terraform', 'Prometheus / Grafana', 'Jenkins / GitHub Actions'],
    approach: 'We assess your current estate, design a secure landing zone, then migrate services with automated IaC and observability. We prioritize reliability and cost optimization.',
    typicalDuration: '1 - 6 months',
    teamSize: '2 - 6'
  },
  {
    slug: 'ui-ux',
    title: 'UI / UX Design',
    short: 'User-centered design that converts and retains.',
    image: 'https://images.unsplash.com/photo-1492724441997-5dc865305da7?w=1400&q=80&auto=format&fit=crop',
    description: `Our product designers run rapid research, prototype flows, and deliver pixel-perfect UI and design systems. We balance business goals with user needs to create intuitive interactions and consistent visual language across platforms.`,
    features: [
      'User research & testing',
      'Design systems & tokens',
      'Interactive prototypes',
      'Brand & visual identity'
    ],
    tech: ['Figma', 'Storybook', 'Design tokens', 'Accessibility (WCAG)'],
    approach: 'We start with generative research, create personas and user journeys, run usability tests on prototypes, and ship a design system that accelerates engineering handoff.',
    typicalDuration: '4 - 12 weeks',
    teamSize: '2 - 4'
  }
];

export default services;
